export const StrategyLabels = {
  Exp5YRExNet:
    'Expected Excess Return Over Market Benchmark - Net of Trading Costs',
  Exp5YRExGross: 'Expected Excess Return Over Market Benchmark',
  Exp5YRTrackingError: 'Tracking Error',
  Exp5YRInfoRatio: 'Information Ratio (Gross)',
  Exp5YREx95th: 'Confidence Interval: Excess Return (Gross)',
  Exp5YREx75th: 'Confidence Interval: Excess Return (Gross)',
  Exp5YREx25th: 'Confidence Interval: Excess Return (Gross)',
  Exp5YREx5th: 'Confidence Interval: Excess Return (Gross)',
  Exp5YRRealNet: 'Real Return',
  Exp5YRRealGross: 'Real Return',
  Exp5YRReal95th: 'Confidence Interval: Real Return (Gross)',
  Exp5YRReal75th: 'Confidence Interval: Real Return (Gross)',
  Exp5YRReal25th: 'Confidence Interval: Real Return (Gross)',
  Exp5YRReal5th: 'Confidence Interval: Real Return (Gross)',
  Exp5YRNomNet: 'Nominal Return',
  Exp5YRNomGross: 'Nominal Return',
  Exp5YRNom95th: 'Confidence Interval: Nominal Return (Gross)',
  Exp5YRNom75th: 'Confidence Interval: Nominal Return (Gross)',
  Exp5YRNom25th: 'Confidence Interval: Nominal Return (Gross)',
  Exp5YRNom5th: 'Confidence Interval: Nominal Return (Gross)',
  Exp5YRVol: 'Volatility',
  Exp5YRSharpe: 'Sharpe Ratio',
  Exp5YRBeta: 'Market Beta',
  HistITDExNet: 'Excess Return Over Market Benchmark',
  HistITDExGross: 'Excess Return Over Market Benchmark',
  HistITDTrackingError: 'Tracking Error',
  HistITDInfoRatio: 'Information Ratio (Gross)',
  HistITDRealNet: 'Real Return',
  HistITDRealGross: 'Real Return',
  HistITDNomNet: 'Nominal Return',
  HistITDNomGross: 'Nominal Return',
  HistITDStructAlpha: 'Structural Alpha',
  HistITDRevalAlpha: 'Revaluation Alpha',
  HistITDVol: 'Volatility',
  HistITDSharpe: 'Sharpe Ratio',
  HistITDBeta: 'Market Beta',
  Hist5YRExNet: 'Excess Return Over Market Benchmark',
  Hist5YRExGross: 'Excess Return Over Market Benchmark',
  Hist5YRTrackingError: 'Tracking Error',
  Hist5YRInfoRatio: 'Information Ratio (Gross)',
  Hist5YRRealNet: 'Real Return',
  Hist5YRRealGross: 'Real Return',
  Hist5YRNomNet: 'Nominal Return',
  Hist5YRNomGross: 'Nominal Return',
  Hist5YRVol: 'Volatility',
  Hist5YRSharpe: 'Sharpe Ratio',
  Hist5YRBeta: 'Market Beta',
  CurrentRelValAgg: 'Current (Aggregate)',
  RelValPB50th: 'Median (P/B)',
  RelValAgg50th: 'Median (Aggregate)',
  CurrentRelValPB: 'Current (P/B)',
  MedianPBVal: 'Median (P/B)',
  TranCost: 'Estimated Trading Cost',
  Capacity: 'Capacity',
  Turnover: 'Turnover',
  WAMC: 'Weighted Average Market Cap',
  EffStockCount: 'Effective Number of Stocks',
  Subsequent5YR: 'Subsequent 5-Yr. Excess Return (Ann.)',
  Subsequent5YRLine: 'Expected 5-Yr. Excess Return (Ann.)',
  WealthGrowth: 'Wealth Growth Over Market Benchmark',
  Exp5YRExReturn: '5-Yr. Excess Return (Ann.)',
  Exp5YRExReturnLine: 'Realized 5-Yr. Excess Return (Ann.)',
  RelValAgg: 'Relative Valuation'
}

export const FactorLabels = {
  Exp5YRReturn: 'Expected Return',
  Exp5YRVol: 'Volatility',
  Exp5YRBeta: 'Market Beta',
  Exp5YRSharpe: 'Sharpe Ratio',
  Exp5YR95th: 'Confidence Interval: Expected Return (Gross)',
  Exp5YR75th: 'Confidence Interval: Expected Return (Gross)',
  Exp5YR25th: 'Confidence Interval: Expected Return (Gross)',
  Exp5YR5th: 'Confidence Interval: Expected Return (Gross)',
  HistITDReturn: 'Historical Return',
  HistITDStructAlpha: 'Structural Alpha',
  HistITDRevalAlpha: 'Revaluation Alpha',
  HistITDVol: 'Volatility',
  HistITDSharpe: 'Sharpe Ratio',
  HistITDBeta: 'Market Beta',
  Hist5YRReturn: 'Historical Return',
  Hist5YRSharpe: 'Sharpe Ratio',
  Hist5YRBeta: 'Market Beta',
  Hist5YRVol: 'Volatility',
  CurrentRelValAgg: 'Current (Aggregate)',
  RelValAgg50th: 'Median (Aggregate)',
  CurrentRelValPB: 'Current (P/B)',
  RelValPB50th: 'Median (P/B)',
  Subsequent5YR: 'Expected 5-Yr. Return (Ann.)',
  Subsequent5YRLine: 'Expected 5-Yr. Return (Ann.)',
  WealthGrowth: 'Wealth Growth',
  Exp5YRExReturn: '5-Yr. Return (Ann.)',
  Exp5YRExReturnLine: 'Realized 5-Yr. Return (Ann.)',
  RelValAgg: 'Relative Valuation'
}



// WEBPACK FOOTER //
// ./src/config/attribute-labels.js